import { useAuth } from '../context/AuthContext.jsx'

export default function NoAccess() {
  const { signOut } = useAuth()

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        fontFamily: 'Inter, sans-serif',
        background: 'var(--bg, #fafafa)',
      }}
    >
      <div
        className="section-card"
        style={{
          maxWidth: 480,
          width: '100%',
          padding: 32,
          textAlign: 'center',
          background: 'var(--card, #fff)',
          border: '1px solid var(--border, #e5e5e7)',
          borderRadius: 12,
          boxShadow: '0 6px 20px rgba(0,0,0,0.04)',
        }}
      >
        <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 12 }}>Sem acesso</div>
        <p style={{ fontSize: 14, color: 'var(--ter, #6e6e73)', lineHeight: 1.5, marginBottom: 24 }}>
          Sua conta está autenticada, mas ainda não tem acesso a nenhuma organização ou cliente.
          Peça a um administrador para te incluir, ou aguarde o convite chegar.
        </p>
        <button
          className="btn btn-black btn-sm"
          onClick={() => signOut()}
          style={{ padding: '8px 16px' }}
        >
          Sair
        </button>
      </div>
    </div>
  )
}
